<script setup lang="ts">
defineProps<{
  show?: boolean;
}>();
</script>

<template>
  <div v-if="show" class="fixed inset-0 pointer-events-none z-[9999]">
    <!-- Indicateur de breakpoint actuel -->
    <div
      class="fixed top-4 left-4 bg-black/80 text-white px-3 py-2 rounded-lg text-xs font-mono pointer-events-auto"
    >
      <span class="block xxs:hidden">default (&lt;375px)</span>
      <span class="hidden xxs:block xs:hidden">xxs (375px+)</span>
      <span class="hidden xs:block sm:hidden">xs (480px+)</span>
      <span class="hidden sm:block md:hidden">sm (640px+)</span>
      <span class="hidden md:block mdd:hidden">md (768px+)</span>
      <span class="hidden mdd:block lg:hidden">mdd (896px+)</span>
      <span class="hidden lg:block xl:hidden">lg (1024px+)</span>
      <span class="hidden xl:block 2xl:hidden">xl (1280px+)</span>
      <span class="hidden 2xl:block">2xl (1536px+)</span>
    </div>

    <!-- Lignes verticales pour les breakpoints -->
    <!-- xxs: 375px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-purple-500/70 left-[375px]">
      <span
        class="absolute top-20 -left-10 bg-purple-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        xxs 375px
      </span>
    </div>

    <!-- xs: 480px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-blue-500/70 left-[480px]">
      <span
        class="absolute top-32 -left-10 bg-blue-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        xs 480px
      </span>
    </div>

    <!-- sm: 640px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-green-500/70 left-[640px]">
      <span
        class="absolute top-44 -left-10 bg-green-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        sm 640px
      </span>
    </div>

    <!-- md: 768px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-yellow-500/70 left-[768px]">
      <span
        class="absolute top-56 -left-10 bg-yellow-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        md 768px
      </span>
    </div>

    <!-- mdd: 896px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-orange-500/70 left-[896px]">
      <span
        class="absolute top-[17rem] -left-10 bg-orange-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        mdd 896px
      </span>
    </div>

    <!-- lg: 1024px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-red-500/70 left-[1024px]">
      <span
        class="absolute top-80 -left-10 bg-red-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        lg 1024px
      </span>
    </div>

    <!-- xl: 1280px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-pink-500/70 left-[1280px]">
      <span
        class="absolute top-96 -left-10 bg-pink-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        xl 1280px
      </span>
    </div>

    <!-- 2xl: 1536px -->
    <div class="absolute top-0 bottom-0 w-0.5 bg-indigo-500/70 left-[1536px]">
      <span
        class="absolute top-[28rem] -left-10 bg-indigo-500 text-white px-2 py-1 rounded text-xs font-mono whitespace-nowrap font-bold"
      >
        2xl 1536px
      </span>
    </div>

    <!-- Grid de colonnes optionnel -->
    <div
      class="absolute inset-0 max-w-7xl mx-auto grid grid-cols-12 gap-4 px-4 opacity-20"
    >
      <div
        v-for="i in 12"
        :key="i"
        class="bg-blue-500/20 border border-blue-500/30"
      />
    </div>
  </div>
</template>
